import { csx } from '@vtex/admin-ui'

export const stacked = csx({
  '>div': {
    padding: '$space-6',
    border: '$neutral',
    ':first-child': {
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
    },
    ':not(:first-child)': {
      borderTop: 'none',
    },
    ':last-child': {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
  },
})
